export default __webpack_public_path__ + "static/media/loan_grey.cae7439b.svg";